import {z} from 'zod'
import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {useTranslation} from '@/translations/i18n'
import {medicalReportJobTypeToLabel, qualificationMapToLabel, workingConditionMapToLabel} from '../../utils'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Label} from '@/components/ui/label/Label'
import {RadioSteps} from '@/components/commons/radio-steps/RadioSteps'
import {ObjectKeys} from '@/utilities/helpers'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Controller, useFormContext} from 'react-hook-form'
import {MedicalReportFieldsSchema} from '../../formSchemas'
import {MedicalReportJobType} from '../../types'

const QualificationJobSchema = MedicalReportFieldsSchema.pick({
    qualification: true,
    workingCondition: true,
    jobType: true
})
type QualificationJobSchema = z.infer<typeof QualificationJobSchema>

export const QualificationJobFields = () => {
    const {t} = useTranslation()
    const form = useFormContext<QualificationJobSchema>()

    return (
        <Grid columns={3} gap={4} fullWidth>
            <GridItem>
                <Controller
                    control={form.control}
                    name="qualification"
                    render={({field, fieldState}) => (
                        <InputSelect
                            placeholder={t('commons:select')}
                            label={t('commons:qualification')}
                            value={field.value}
                            optionsMap={qualificationMapToLabel}
                            errorMessage={fieldState.error?.message}
                            onChange={field.onChange}
                        />
                    )}
                />
            </GridItem>
            <GridItem>
                <Controller
                    control={form.control}
                    name="workingCondition"
                    render={({field, fieldState}) => (
                        <InputSelect
                            placeholder={t('commons:select')}
                            label={t('medical_records:working_condition')}
                            value={field.value}
                            optionsMap={workingConditionMapToLabel}
                            errorMessage={fieldState.error?.message}
                            onChange={field.onChange}
                        />
                    )}
                />
            </GridItem>
            <GridItem>
                <Flexbox gap={1.5} direction="column">
                    <Label>{t('medical_records:job_type')}</Label>
                    <Controller
                        control={form.control}
                        name="jobType"
                        render={({field}) => (
                            <RadioSteps<MedicalReportJobType>
                                name={field.name}
                                onChange={value => field.onChange(value)}
                                value={field.value}
                                steps={ObjectKeys(medicalReportJobTypeToLabel).map(item => ({
                                    label: t(medicalReportJobTypeToLabel[item]),
                                    value: item
                                }))}
                            />
                        )}
                    />
                </Flexbox>
            </GridItem>
        </Grid>
    )
}
